import { render, staticRenderFns } from "./StandingsPlayerDetailsSection.vue?vue&type=template&id=60775b59&scoped=true"
import script from "./StandingsPlayerDetailsSection.vue?vue&type=script&lang=ts"
export * from "./StandingsPlayerDetailsSection.vue?vue&type=script&lang=ts"
import style0 from "./StandingsPlayerDetailsSection.vue?vue&type=style&index=0&id=60775b59&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60775b59",
  null
  
)

export default component.exports